export default __webpack_public_path__ + "static/media/Scenario6.30ea4e66.mp4";